import brooklawn from "./brooklawn.json";
import greenwood from "./greenwood.json";

const DATA = {
    greenwood,
    brooklawn,
};

export default DATA[import.meta.env.VITE_VENDOR_SLUG];
